import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FrontPageComponent } from './front-page.component';

const routes: Routes = [
  //{ path: ':lang/:education-type/:education-type-id/o', pathMatch: 'full', component: FrontPageComponent, runGuardsAndResolvers: 'always' },
  { path: ':lang/index', pathMatch: 'full', component: FrontPageComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FrontPageRoutingModule { }
